import React from "react";
import { NavLink } from "react-router-dom";
import {
  homeURL,
  privacypolicyURL,
  termsandconditionURL,
} from "../../helpers/paths";
import { callicon, emailicon, everestlogo } from "../../source";
import "./footer.scss";
import useWindowDimensions from "../../hooks/useWindowDimensions";
// import TermModal from "../TermsModal/TermsModal";
import RegisterNow from "../RegisterNow/RegisterNow";

const Footer = () => {
  const { width } = useWindowDimensions();

  const today = new Date();
  const scrollHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="footer_sec1">
        <div className="my_container">
          <div className="row footer_main">
            <div className="logo_wrapper">
              <a href={homeURL}>
                <img
                  className="footer_logo"
                  onClick={scrollHandler}
                  src={everestlogo}
                  alt="logo"
                  // data-aos="fade"
                />
              </a>
            </div>
            {/* <div className="col-md-3 col-lg-3">
              <div className="logo_wrapper">
                <a href={homeURL}>
                  <img
                    className="footer_logo"
                    onClick={scrollHandler}
                    src={everestlogo}
                    alt="logo"
                    data-aos="fade"
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="links_wrapper">
                <h4 className="link_heading">Quick Links</h4>
                <ul className="link_list">
                   <Link className="link" to="/">
                    <li>ABOUT US</li>
                  </Link> 
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              {/* <div className="links_wrapper">
                <h4 className="link_heading">Contact Us</h4>
                <p className="description">
                  {" "}
                  <a href="https://goo.gl/maps/hYDfWJgLUkjZbJUL6">
                    <img
                      src={footerlocation}
                      alt="location"
                      className="location_icon"
                    />
                    Equinox Business Park, Ambedkar Nagar, Kurla West, Mumbai,
                    Maharashtra 400070
                  </a>
                </p>
                <ul className="link_list">
                  <a className="link" href="mailto:everest@gmail.com">
                    <li>
                      <img
                        src={footermail}
                        alt="location"
                        className="location_icon"
                      />
                      <div className="text_part">everest@gmail.com</div>
                    </li>
                  </a>
                  <a className="link" href="tel:+91 1234 567 890">
                    <li>
                      <img
                        src={footercall}
                        alt="location"
                        className="location_icon"
                      />
                      <div className="text_part">+91 1234 567 890</div>
                    </li>
                  </a>
                </ul>
              </div> 
            </div>
            <div className="col-md-3 col-lg-3">
              <div className="links_wrapper external_link">
                <h4 className="link_heading">Information</h4> 
                <ul className="link_list">
                 <Link className="link" to={privacypolicyURL}>
                    <li>PRIVACY POLICY</li>
                  </Link>
                  <Link className="link" to={termsandconditionURL}>
                    <li>TERMS & CONDITIONS</li>
                  </Link>
                </ul>
                <div className="link" >
                  <li>Terms & Conditions</li>
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      </section>
      <section className="footer_sec2">
        <div className="my_container">
          <div className="copyright_flex">
            <p className="copyright order-md-2">
              <a
                className="contact_link term_link"
                href={privacypolicyURL}
                target="_blank"
              >
                <li>Privacy Policy</li>
              </a>
            </p>
            <p className="copyright order-md-3">
              {/* <a className="contact_link" href="tel:+912240997700">
                <img
                  width={50}
                  height={50}
                  src={callicon}
                  alt="call"
                  className="contact_icon"
                  loading="lazy"
                />
                + 91 22 40997700
              </a> */}
              <a
                className="contact_link"
                href="mailto:tastemasters@everestspices.com"
              >
                <img
                  width={50}
                  height={50}
                  src={emailicon}
                  alt="call"
                  className="contact_icon"
                  loading="lazy"
                />
                tastemasters@everestspices.com
              </a>
            </p>
            <p className="copyright image_disclaimer order-md-1">
              <span>
                Copyright © {today.getFullYear()} Everest Spices.{" "}
                {width < 600 && <br />}All rights reserved.
              </span>
            </p>
          </div>
        </div>
      </section>
      {width <= 1080 && <RegisterNow />}
    </>
  );
};

export default Footer;
